import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Workspace"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 12.75V18.75H4.5V12.75H12ZM12 11.25H4.5C3.67157 11.25 3 11.9216 3 12.75V18.75C3 19.5784 3.67157 20.25 4.5 20.25H12C12.8284 20.25 13.5 19.5784 13.5 18.75V12.75C13.5 11.9216 12.8284 11.25 12 11.25ZM20.25 4.5V8.25H12.75V4.5H20.25ZM20.25 3H12.75C11.9216 3 11.25 3.67157 11.25 4.5V8.25C11.25 9.07843 11.9216 9.75 12.75 9.75H20.25C21.0784 9.75 21.75 9.07843 21.75 8.25V4.5C21.75 3.67157 21.0784 3 20.25 3ZM20.25 12.75V16.5H16.5V12.75H20.25ZM20.25 11.25H16.5C15.6716 11.25 15 11.9216 15 12.75V16.5C15 17.3284 15.6716 18 16.5 18H20.25C21.0784 18 21.75 17.3284 21.75 16.5V12.75C21.75 11.9216 21.0784 11.25 20.25 11.25ZM8.25 4.5V8.25H4.5V4.5H8.25ZM8.25 3H4.5C3.67157 3 3 3.67157 3 4.5V8.25C3 9.07843 3.67157 9.75 4.5 9.75H8.25C9.07843 9.75 9.75 9.07843 9.75 8.25V4.5C9.75 3.67157 9.07843 3 8.25 3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Workspace.vue"]]);
